'use strict';

var d3 = require('d3');
var _ = require('lodash');
var FilterBars = function FilterBars(d3Helper) {
  return function (yPropertiesNames, xPropertyName) {
    var params, scales, selectedLengthOfStay;
    var bars = function bars(container) {
      var group = container.select('.groups').selectAll('.stack.visible');
      group.each(function (d) {
        var filterGroup = d3Helper.createGroupElement(d3.select(this), 'filter-group');
        filterGroup.selectAll('rect').remove();
        if (!_.isArray(selectedLengthOfStay)) {
          return d;
        }
        if (_.indexOf(selectedLengthOfStay, d[xPropertyName]) > -1) {
          var yPropertyMax = _.chain(yPropertiesNames).map(function (yPropertyName) {
            return {
              property: yPropertyName,
              value: d[yPropertyName]
            };
          }).maxBy('value').value();
          var filterBars = filterGroup.selectAll('.filter-group').data([d]);
          filterBars.enter().append('rect');
          filterBars.attr({
            'class': function _class() {
              return 'filtered-length-of-stay';
            },
            'width': function width() {
              return params.xDataSize - params.xBarPadding * 2;
            },
            'y': function y(d) {
              var tempMax = yPropertyMax.value;
              var tempY = scales.yScale(tempMax);
              var tempHeight = Math.abs(scales.yScale(0) - scales.yScale(d[yPropertyMax.property]));
              if (d[yPropertyMax.property] !== 0 && tempHeight === 0) {
                tempY = tempY - 1;
              }
              return tempY;
            },
            'x': function x() {
              return params.xBarPadding;
            },
            'height': function height(d) {
              var tempHeight = Math.abs(scales.yScale(0) - scales.yScale(d[yPropertyMax.property]));
              if (d[yPropertyMax.property] !== 0 && tempHeight === 0) {
                tempHeight = tempHeight + 1;
              }
              return tempHeight;
            }
          });
        }
      });
    };
    bars.params = function (value) {
      params = value;
      return bars;
    };
    bars.scales = function (value) {
      scales = value;
      return bars;
    };
    bars.withSelection = function (value) {
      selectedLengthOfStay = value;
      return bars;
    };
    return bars;
  };
};
FilterBars.$inject = ['d3Helper'];
module.exports = FilterBars;